module.exports = __webpack_public_path__ + "static/media/tid-btn.0d35f843.svg";